import {Dispatch, FC, SetStateAction} from 'react'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import {FieldHelpLabel} from '../../../../../../_metronic/helpers/components/FieldHelp'
import {
  InvoiceArticle9IssueDateAccessory,
  InvoiceArticle9RegistrationField,
} from '../components/InvoiceArticle9Fields'

type Props = {
  date: string
  setDate: Dispatch<SetStateAction<string>>
  description: string
  setDescription: Dispatch<SetStateAction<string>>
  now: string
  loading: boolean
  canSave: boolean
  onSave: () => void
  invoiceType: number
  isArticle9: boolean
  setIsArticle9: Dispatch<SetStateAction<boolean>>
  registrationDateTime: string
  setRegistrationDateTime: Dispatch<SetStateAction<string>>
}

const InvoiceCancellationPanel: FC<Props> = ({
  date,
  setDate,
  description,
  setDescription,
  now,
  loading,
  canSave,
  onSave,
  invoiceType,
  isArticle9,
  setIsArticle9,
  registrationDateTime,
  setRegistrationDateTime,
}) => (
  <section className='mp-cancellation-panel'>
    <div className='mp-cancellation-panel__heading'>
      <span>
        <i className='las la-ban'></i>
      </span>
      <div>
        <h3><FieldHelpLabel label='اطلاعات صورتحساب ابطالی' helpKey='section.header' /></h3>
        <p>
          برای ابطال، تکمیل تاریخ و شناسه مرجع کافی است. توضیحات اختیاری اما برای سوابق داخلی
          پیشنهاد می‌شود.
        </p>
      </div>
    </div>
    <div className='row g-6'>
      <div className='col-12 col-lg-6'>
        <CustomInputs
          type='datepicker'
          label={
            <>تاریخ و زمان صدور صورتحساب ابطالی</>
          }
          labelAccessory={
            <InvoiceArticle9IssueDateAccessory
              invoiceType={invoiceType}
              issueDateTime={date}
              isArticle9={isArticle9}
              setIsArticle9={setIsArticle9}
            />
          }
          isRequired
          timePicker
          stateValue={{value: date, setValue: setDate}}
          limitToDate={now}
        />
      </div>
      {(isArticle9 || invoiceType === 3) && (
        <div className='col-12 col-lg-6'>
          <InvoiceArticle9RegistrationField
            invoiceType={invoiceType}
            issueDateTime={date}
            now={now}
            isArticle9={isArticle9}
            setIsArticle9={setIsArticle9}
            registrationDateTime={registrationDateTime}
            setRegistrationDateTime={setRegistrationDateTime}
          />
        </div>
      )}
      <div className='col-12'>
        <label htmlFor='cancellation-description' className='form-label fw-semibold'>
          <FieldHelpLabel
            label={<>توضیحات <span className='text-gray-500 fw-normal'>(اختیاری)</span></>}
            helpKey='ui.invoiceDescription'
          />
        </label>
        <textarea
          id='cancellation-description'
          className='form-control'
          rows={4}
          maxLength={1000}
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          placeholder='برای نمونه: معامله انجام نشد یا اطلاعات پایه‌ای صورتحساب مرجع نیاز به تغییر دارد.'
        />
        <div className='text-gray-500 fs-8 mt-2'>{description.length}/1000 کاراکتر</div>
      </div>
    </div>
    <div className='mp-cancellation-panel__footer'>
      <span>
        <i className='las la-shield-alt'></i> سایر اطلاعات صورتحساب مرجع در این عملیات دریافت
        نمی‌شود.
      </span>
      <button
        type='button'
        className='btn btn-danger'
        disabled={!canSave || loading}
        onClick={onSave}
      >
        {loading ? (
          <span className='spinner-border spinner-border-sm me-2'></span>
        ) : (
          <i className='las la-check fs-2'></i>
        )}
        ثبت صورتحساب ابطالی
      </button>
    </div>
  </section>
)

export {InvoiceCancellationPanel}
